import {EmailStep} from "@/app/auth/signup/signup.components/wizard/steps/email-step.tsx";
import {PlainSignupForm} from "@/app/auth/signup/signup.components/wizard/steps/plain-signup-form.tsx";
import {OrgInviteSignupForm} from "@/app/auth/signup/signup.components/wizard/steps/org-invite-signup-form.tsx";
import {IndividualInviteSignupForm} from "@/app/auth/signup/signup.components/wizard/steps/individual-invite-signup-form.tsx";
import {TeamMemberInviteSignupForm} from "@/app/auth/signup/signup.components/wizard/steps/team-member-invite-signup-form.tsx";
import {useWizard} from "@/app/auth/signup/signup.components/wizard/wizard.hooks.ts";
import VerifyEmailPending from "@/app/auth/signup/signup.components/wizard/steps/verify-email-pending.tsx";

export default function Wizard() {
    const { step, email, inviteToken, needsVerification } = useWizard();

    if (needsVerification) return <VerifyEmailPending />;

    switch (step) {
        case "email":
            return <EmailStep />;
        case "plain":
            return <PlainSignupForm prefilledEmail={email!} />;
        case "orgInvite":
            return (
                <OrgInviteSignupForm
                    prefilledEmail={email!}
                    inviteToken={inviteToken!}
                />
            );
        case "individualInvite":
            return (
                <IndividualInviteSignupForm
                    prefilledEmail={email!}
                    inviteToken={inviteToken!}
                />
            );
        case "teamMemberInvite":
            return (
                <TeamMemberInviteSignupForm
                    prefilledEmail={email!}
                    inviteToken={inviteToken!}
                />
            );
    }
}